// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";

const fragments = {
  POLL_EMAIL_INPUT: '[data-fragment="Poll.pollEmailInput"]',
  POLL_RADIO_INPUT: '[data-fragment="Poll.pollRadioInput"]',
  POLL_SUBMIT_BUTTON: '[data-fragment="Poll.pollSubmitButton"]'
};

export default class Poll extends WebComponent {
  constructor(props) {
    super(props);
    const {
      radioUrl
    } = this.props;

    this.state = {
      radioUrl
    };
  }

  didMount() {
    this.changeListeners();
    this.clickListeners();
    /*   this.on('keyup', fragments.POLL_EMAIL_INPUT, this.debounce(function (e) {
         dispatchEvent(e.target, 'requestValidation', false)
       }, 500));*/
    this.sendListener();
  }

  sendListener() {
    let _self = this;
    document.querySelectorAll(fragments.POLL_SUBMIT_BUTTON).forEach(function (e) {
      e.addEventListener('click', (e) => {
        const pollId = e.target.getAttribute('data-poll-id');
        const emailErrorInput = document.querySelector('input[data-poll-name=email-' + pollId + '].has-error');

        if (emailErrorInput) {
          e.preventDefault();
        } else {
          _self.scrollToAnchor();
        }
      });
    });
  }


  changeListeners() {
    let _self = this;
    document.querySelectorAll(fragments.POLL_EMAIL_INPUT).forEach(function (e) {
      e.addEventListener('change', (e) => {
        const pollId = e.target.getAttribute('data-poll-id');
        _self.emailInputAction(pollId);
      });
    });
  }

  clickListeners() {
    let _self = this;
    document.querySelectorAll(fragments.POLL_RADIO_INPUT).forEach(function (e) {
      e.addEventListener('click', (e) => {
        const pollId = e.target.getAttribute('data-poll-id');
        const pollUrl = e.target.getAttribute('data-vote-url');

        _self.radioInputAction(pollId, pollUrl);
      });
    });
  }

  emailInputAction(pollId) {
    const {
      radioUrl
    } = this.state;

    const emailInput = document.querySelector('input[data-poll-name="email-' + pollId + '"]').value;
    const submitButton = document.getElementById('pollSubmitButton-' + pollId);
    const helpBlock = document.getElementById('help-block-' + pollId);
    let helpBlockText = helpBlock.getAttribute('data-message');
    let formAction = document.getElementById('poll-submit-form-' + pollId);

    if ((this.validateEmail(emailInput)) && (radioUrl)) {
      // !!! voteText -> GDPR propojení (GDPR = poll.xml - interceptor) !!!
      let radioInputEvent = radioUrl + '&voteText=' + emailInput;
      submitButton.removeAttribute('disabled');
      formAction.setAttribute('action', radioInputEvent);
      helpBlock.innerHTML="";
    } else {
      formAction.setAttribute('action', '');
      submitButton.disabled = true;
      helpBlock.innerHTML=helpBlockText;
    }
  }


  radioInputAction(pollId, pollUrl) {
    this.setState({
      radioUrl: pollUrl
    });

    this.emailInputAction(pollId);
  }

  scrollToAnchor() {
    const anchor = document.getElementById('perexContainer');
    anchor.scrollIntoView();
  }

/*  debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
  };*/

  validateEmail(email) {
    let re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
  }

  willUnmount() {

  }
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/Poll.js